import React from "react";
import "./Cancel.css";
import { Link } from "react-router-dom";

const Cancel = () => {
  return (
    <div className="cancel-page">
      <div className="cancel-content">
        <h1>Payment Canceled</h1>
        <p>Your payment was not completed.</p>
        <p>If you have any questions, please contact our support.</p>
        <Link to="/" className="cancel-button">
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default Cancel;
